export const isTodayUTC = (date: Date) => {
  const todayUTC = new Date();
  return (
    date.getUTCFullYear() === todayUTC.getUTCFullYear() &&
    date.getUTCMonth() === todayUTC.getUTCMonth() &&
    date.getUTCDate() === todayUTC.getUTCDate()
  );
};
